module.exports = __webpack_public_path__ + "img/unknown-icon.a3da1562.svg";